import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Acerca from "./views/Acerca.vue";
import Productos from "./views/Productos.vue";
import CapsulasBlandas from "./views/Capsulas Blandas.vue";
import MateriaPrima from "./views/Materia Prima.vue";
import Contacto from "./views/Contacto.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/nosotros",
      name: "nosotros",
      component: Acerca
    },
    {
      path: "/productos",
      name: "productos",
      component: Productos
    },
    {
      path: "/capsulas-blandas",
      name: "capsulas blandas",
      component: CapsulasBlandas
    },
    {
      path: "/materia-prima",
      name: "materia prima",
      component: MateriaPrima
    },
    {
      path: "/contacto",
      name: "contactp",
      component: Contacto,
    }
  ],
  mode: 'history'
});
